import { AssignmentModel } from '../../../../api-service/clients';
import { DeepPartial, ServiceProviderAssignmentErrors } from '../../common/assignment/interfaces';

export interface SpAssignmentValidationInput {
  backgroundInformation?: DeepPartial<AssignmentModel>['backgroundInformation'];
  assessmentInformation?: DeepPartial<AssignmentModel>['assessmentInformation'];
  commissionedIntervention?: DeepPartial<AssignmentModel>['commissionedIntervention'];
  activityOfferId?: string;
}

export function validateSpAssignment(input: SpAssignmentValidationInput): ServiceProviderAssignmentErrors {
  const errors: ServiceProviderAssignmentErrors = {} as ServiceProviderAssignmentErrors;
  const { backgroundInformation, assessmentInformation, commissionedIntervention } = input;

  if (backgroundInformation?.name && backgroundInformation.name.length > 255) {
    errors.name = 'Navn må maksimalt være 255 tegn.';
  }

  if (!backgroundInformation?.name || backgroundInformation.name.trim() === '') {
    errors.name = 'Navn er påkrævet.';
  }

  if (!backgroundInformation?.companyId) {
    errors.companyId = 'Virksomhed er påkrævet.';
  }

  if (!backgroundInformation?.responsibleUserId) {
    errors.responsibleUserId = 'Ansvarlig medarbejder/team er påkrævet.';
  }

  if (!assessmentInformation?.primaryAssessmentTopicId) {
    errors.primaryAssessmentTopicId = 'Borgers primære målgruppe er påkrævet.';
  }

  if (!assessmentInformation?.assessmentSummary?.trim()) {
    errors.assessmentSummary = 'Vurdering af borgers situation er påkrævet.';
  }

  if (!assessmentInformation?.citizenSupportNeedsAssessment?.trim()) {
    errors.citizenSupportNeedsAssessment = 'Vurdering af borgers støttebehov og indsats er påkrævet.';
  }

  if (!assessmentInformation?.citizenPerspectiveInfo?.trim()) {
    errors.citizenPerspectiveInfo = 'Borgers perspektiv på indsatsen er påkrævet.';
  }

  if (!assessmentInformation?.citizenAssessmentResourceInfo?.trim()) {
    errors.citizenAssessmentResourceInfo = 'Borgers ressourcer i forhold til indsatsen er påkrævet.';
  }

  if (!assessmentInformation?.challengesAndNeedsInfo?.trim()) {
    errors.challengesAndNeedsInfo = 'Borgers aktuelle støttebehov er påkrævet.';
  }

  if (!assessmentInformation?.citizenFutureAspirationsInfo?.trim()) {
    errors.citizenFutureAspirationsInfo = 'Borgers ønsker for fremtiden er påkrævet.';
  }

  if (!assessmentInformation?.citizenAssessmentPurposeInfo?.trim()) {
    errors.citizenAssessmentPurposeInfo = 'Indsatsformål er påkrævet.';
  }

  if (!commissionedIntervention?.grantTypeId) {
    errors.grantTypeId = 'Bevillingstype er påkrævet.';
  }

  if (commissionedIntervention?.grantTypeId && !input.activityOfferId) {
    errors.grantTypeId = 'Vælg en bevillingstype med tilbud.';
  }

  if (!commissionedIntervention?.benefitTypeIds || commissionedIntervention.benefitTypeIds.length === 0) {
    errors.benefitTypeIds = 'Du skal vælge mindst én ydelse.';
  }

  if (commissionedIntervention?.reportingFrequency === null || commissionedIntervention?.reportingFrequency === undefined) {
    errors.reportingFrequency = 'Frekvens for rapportering er påkrævet.';
  }

  if (!commissionedIntervention?.followUpDate) {
    errors.followUpDate = 'Opfølgningsdato er påkrævet.';
  }

  if (!commissionedIntervention?.agreementsBetweenAuthorityAndProvider?.trim()) {
    errors.agreementsBetweenAuthorityAndProvider = 'Aftaler mellem myndighed og udfører om indsatsen er påkrævet.';
  }

  return errors;
}
